import { Heading, VFlow } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { TitleGroup } from 'components/TitleGroup'
import { css } from 'emotion'
import { TipoGrupoParticipanteAtividadeColetivaEnum } from 'graphql/types.generated'
import React, { Fragment } from 'react'
import { LotacoesEnvolvidasTable } from 'view/atividade-coletiva/componentes/LotacoesEnvolvidasTable'

import { AtividadeColetivaGruposInfoHeader } from '../AtividadeColetivaGruposInfoHeader'
import { CidadaoTable } from '../CidadaoTable'
import { AtividadeColetivaGruposModel } from '../model-atividadeColetivaGrupos'

interface AtividadeColetivaGruposVisualizarViewProps {
  atividadeColetivaGrupo: AtividadeColetivaGruposModel
}

export const AtividadeColetivaGruposVisualizarView = (props: AtividadeColetivaGruposVisualizarViewProps) => {
  const { atividadeColetivaGrupo } = props
  const mustShowParticipantes =
    atividadeColetivaGrupo.tipoGrupo === TipoGrupoParticipanteAtividadeColetivaEnum.ATIVIDADE_EM_SAUDE

  return (
    <Fragment>
      <Breadcrumb title='Visualização de grupo' />
      <PageContent type='filled' style={styles.pageContent}>
        <VFlow vSpacing={2}>
          <TitleGroup title='Grupo de atividade coletiva' />
          <AtividadeColetivaGruposInfoHeader atividadeColetivaGrupo={atividadeColetivaGrupo} />
          <VFlow vSpacing={1.5}>
            <Heading level={2}>Profissionais envolvidos</Heading>
            <LotacoesEnvolvidasTable items={atividadeColetivaGrupo.lotacoesEnvolvidas} />
          </VFlow>
          {mustShowParticipantes && (
            <VFlow vSpacing={1.5}>
              <Heading level={2}>Listagem de participantes</Heading>
              <CidadaoTable items={atividadeColetivaGrupo.cidadaosParticipantes} />
            </VFlow>
          )}
        </VFlow>
      </PageContent>
    </Fragment>
  )
}

const styles = {
  pageContent: css`
    padding-bottom: 3.5rem;
  `,
}
